import styled from '@xstyled/styled-components'

export const MoteCardMediumContainerRoot = styled.divBox({
  position: 'relative',
  backgroundColor: 'white',
  width: 'full',
  minWidth: '204px',
  maxWidth: '393px',
  minHeight: '104px',
  border: '1px',
  borderStyle: 'solid',
  borderColor: 'grey.l2',
  borderRadius: 'lg',
  padding: '3',
  boxSizing: 'border-box',
  outline: 'transparent solid 2px',
  outlineOffset: '2px',
  '& > *': {
    fontFamily: 'sans'
  }
})

export const MoteCardMediumContainerInner = styled.divBox({
  display: 'flex',
  flexDirection: 'column',
  gap: '2',
  boxSizing: 'border-box'
})
